/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AppContext } from '../context/AppContext'
import PaymentReceiveService from '../services/PaymentReceiveService'
import Swal from 'sweetalert2'

const PaymentReceiveList = () => {
    const { currentUser } = useContext(AppContext)
    const [payments, setPayments] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [filterStatus, setFilterStatus] = useState('all')
    const [filterPaymentType, setFilterPaymentType] = useState('all')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [sortBy, setSortBy] = useState('create_date')
    const [sortOrder, setSortOrder] = useState('desc')
    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        total_pages: 0,
        has_next_page: false,
        has_prev_page: false,
        from: 0,
        to: 0
    })

    useEffect(() => {
        fetchPayments()
    }, [currentPage, searchTerm, filterStatus, filterPaymentType, itemsPerPage, sortBy, sortOrder])

    const fetchPayments = async () => {
        setLoading(true)
        
        try {
            const params = {
                page: currentPage,
                per_page: itemsPerPage,
                search: searchTerm,
                status: filterStatus,
                payment_type: filterPaymentType,
                sort_by: sortBy,
                sort_order: sortOrder
            }

            const response = await PaymentReceiveService.getPaymentReceiveList(params)
            
            if (response.success) {
                setPayments(response.data || [])
                setPagination(response.pagination || {})
            } else {
                console.error('Failed to fetch payments:', response.errorMessage)
                setPayments([])
            }
        } catch (error) {
            console.error('Error fetching payments:', error)
            setPayments([])
        } finally {
            setLoading(false)
        }
    }

    const handleSearchChange = (value) => {
        setSearchTerm(value)
        setCurrentPage(1)
    }

    const handleFilterChange = (type, value) => {
        if (type === 'status') {
            setFilterStatus(value)
        } else if (type === 'paymentType') {
            setFilterPaymentType(value)
        } else if (type === 'perPage') {
            setItemsPerPage(parseInt(value))
        } else if (type === 'sortBy') {
            setSortBy(value)
        } else if (type === 'sortOrder') {
            setSortOrder(value)
        }
        setCurrentPage(1)
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const handleDeletePayment = async (paymentId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        })

        if (result.isConfirmed) {
            try {
                const response = await PaymentReceiveService.deletePaymentReceive(paymentId)
                if (response.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Payment has been deleted.',
                        confirmButtonColor: '#3085d6',
                        timer: 2000,
                        showConfirmButton: false
                    })
                    fetchPayments()
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.errorMessage || 'Failed to delete payment',
                        confirmButtonColor: '#d33'
                    })
                }
            } catch (error) {
                console.error('Error deleting payment:', error)
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error deleting payment',
                    confirmButtonColor: '#d33'
                })
            }
        }
    }

    const handleStatusUpdate = async (paymentId, newStatus) => {
        try {
            const response = await PaymentReceiveService.updatePaymentStatus(paymentId, { status: newStatus })
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Updated!',
                    text: 'Payment status updated successfully.',
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
                fetchPayments()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.errorMessage || 'Failed to update payment status',
                    confirmButtonColor: '#d33'
                })
            }
        } catch (error) {
            console.error('Error updating payment status:', error)
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error updating payment status',
                confirmButtonColor: '#d33'
            })
        }
    }

    const getStatusBadge = (status) => {
        const statusInfo = PaymentReceiveService.formatPaymentStatus(status)
        return `badge-${statusInfo.color}`
    }

    const formatDate = (dateString) => {
        return PaymentReceiveService.formatDate(dateString)
    }

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header card-header-mobile'>
                    <div className='card-title'>
                        <h3 className='card-label'>Payment Receive Management</h3>
                    </div>
                    <div className='card-toolbar card-toolbar-mobile'>
                        <Link to="/payments/receive/create" className='btn btn-primary btn-mobile'>
                            <i className="fas fa-plus me-2"></i>
                            <span className="btn-text">Receive Payment</span>
                        </Link>
                        <button 
                            className='btn btn-secondary btn-mobile'
                            onClick={fetchPayments}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    <span className="btn-text">Loading...</span>
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-sync-alt"></i>
                                    <span className="btn-text">Refresh</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>

                <div className='card-body'>
                    {/* Filters */}
                    <div className='filters-container filters-container-mobile mb-4'>
                        {/* Mobile Filters */}
                        <div className='d-lg-none mobile-filters'>
                            <div className='mobile-search-wrapper mb-3'>
                                <div className="position-relative">
                                    <input
                                        type='text'
                                        className='form-control form-control-mobile-search'
                                        placeholder='Search payments...'
                                        value={searchTerm}
                                        onChange={(e) => handleSearchChange(e.target.value)}
                                    />
                                    <div className="search-icon-mobile">
                                        <i className="fas fa-search"></i>
                                    </div>
                                    {loading && (
                                        <div className="search-loading-mobile">
                                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                <span className="visually-hidden">Searching...</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className='mobile-filter-row'>
                                <div className='mobile-filter-item'>
                                    <label className='filter-label-mobile'>Status</label>
                                    <select
                                        className='form-select form-select-mobile'
                                        value={filterStatus}
                                        onChange={(e) => handleFilterChange('status', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Status</option>
                                        <option value='created'>Pending</option>
                                        <option value='approved'>Approved</option>
                                        <option value='rejected'>Rejected</option>
                                    </select>
                                </div>
                                <div className='mobile-filter-item'>
                                    <label className='filter-label-mobile'>Payment Type</label>
                                    <select
                                        className='form-select form-select-mobile'
                                        value={filterPaymentType}
                                        onChange={(e) => handleFilterChange('paymentType', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Types</option>
                                        <option value='cash'>Cash</option>
                                        <option value='bank_transfer'>Bank Transfer</option>
                                        <option value='mobile_banking'>Mobile Banking</option>
                                        <option value='credit_card'>Credit Card</option>
                                        <option value='debit_card'>Debit Card</option>
                                        <option value='check'>Check</option>
                                        <option value='online_payment'>Online Payment</option>
                                        <option value='other'>Other</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Desktop Filters */}
                        <div className='d-none d-lg-block'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <div className="position-relative">
                                        <input
                                            type='text'
                                            className='form-control'
                                            placeholder='Search payments by reference, order, or customer...'
                                            value={searchTerm}
                                            onChange={(e) => handleSearchChange(e.target.value)}
                                            disabled={loading}
                                        />
                                        {loading && (
                                            <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Searching...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-md-2'>
                                    <select
                                        className='form-select'
                                        value={filterStatus}
                                        onChange={(e) => handleFilterChange('status', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Status</option>
                                        <option value='created'>Pending</option>
                                        <option value='approved'>Approved</option>
                                        <option value='rejected'>Rejected</option>
                                    </select>
                                </div>
                                <div className='col-md-2'>
                                    <select
                                        className='form-select'
                                        value={filterPaymentType}
                                        onChange={(e) => handleFilterChange('paymentType', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Types</option>
                                        <option value='cash'>Cash</option>
                                        <option value='bank_transfer'>Bank Transfer</option>
                                        <option value='mobile_banking'>Mobile Banking</option>
                                        <option value='credit_card'>Credit Card</option>
                                        <option value='debit_card'>Debit Card</option>
                                        <option value='check'>Check</option>
                                        <option value='online_payment'>Online Payment</option>
                                        <option value='other'>Other</option>
                                    </select>
                                </div>
                                <div className='col-md-2'>
                                    <select
                                        className='form-select'
                                        value={sortBy}
                                        onChange={(e) => handleFilterChange('sortBy', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='create_date'>Date Created</option>
                                        <option value='amount'>Amount</option>
                                        <option value='status'>Status</option>
                                        <option value='payment_type'>Payment Type</option>
                                        <option value='reference'>Reference</option>
                                    </select>
                                </div>
                                <div className='col-md-1'>
                                    <select
                                        className='form-select'
                                        value={sortOrder}
                                        onChange={(e) => handleFilterChange('sortOrder', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='desc'>Desc</option>
                                        <option value='asc'>Asc</option>
                                    </select>
                                </div>
                                <div className='col-md-2'>
                                    <select
                                        className='form-select'
                                        value={itemsPerPage}
                                        onChange={(e) => handleFilterChange('perPage', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value={10}>10 per page</option>
                                        <option value={20}>20 per page</option>
                                        <option value={50}>50 per page</option>
                                        <option value={100}>100 per page</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Results Summary */}
                    <div className='row mb-3'>
                        <div className='col-12'>
                            <div className='text-muted small'>
                                {pagination.total > 0 ? (
                                    <>
                                        Showing {pagination.from}-{pagination.to} of {pagination.total} payments
                                    </>
                                ) : (
                                    'No payments found'
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Payment List - Desktop Table / Mobile Cards */}
                    <div className='payment-list-container'>
                        {/* Desktop Table View */}
                        <div className='d-none d-lg-block'>
                            <div className='table-responsive'>
                                <table className='table table-striped table-hover'>
                                    <thead className='table-dark'>
                                        <tr>
                                            <th>Reference</th>
                                            <th>Order No</th>
                                            <th>Customer</th>
                                            <th>Amount</th>
                                            <th>Payment Type</th>
                                            <th>Status</th>
                                            <th>Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan='8' className='text-center py-4'>
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <p className="mt-2">Loading payments...</p>
                                                </td>
                                            </tr>
                                        ) : payments.length === 0 ? (
                                            <tr>
                                                <td colSpan='8' className='text-center py-4'>
                                                    <div className='text-muted'>
                                                        <i className='fas fa-money-bill-wave fa-3x mb-3'></i>
                                                        <p>No payments found</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            payments.map((payment) => (
                                                <tr key={payment.id}>
                                                    <td>
                                                        <span className='badge bg-primary text-white'>
                                                            {payment.reference}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Link to={`/sales-orders/${payment.orderId}`} className='text-decoration-none'>
                                                            {payment.orderNo}
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <strong>{payment.customerName}</strong>
                                                            <div className="text-muted small">{payment.mobileNumber}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span className='fw-bold text-success'>
                                                            {PaymentReceiveService.formatCurrency(payment.amount)}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className='badge bg-info'>
                                                            {payment.paymentType}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${getStatusBadge(payment.status)}`}>
                                                            {PaymentReceiveService.formatPaymentStatus(payment.status).label}
                                                        </span>
                                                    </td>
                                                    <td>{formatDate(payment.createdAt)}</td>
                                                    <td>
                                                        <div className='btn-group btn-group-sm'>
                                                            <Link
                                                                to={`/payments/receive/${payment.id}`}
                                                                className='btn btn-outline-primary'
                                                                title='View Details'
                                                            >
                                                                <i className='fas fa-eye'></i>
                                                            </Link>
                                                            <Link
                                                                to={`/payments/receive/edit/${payment.id}`}
                                                                className='btn btn-outline-warning'
                                                                title='Edit Payment'
                                                            >
                                                                <i className='fas fa-edit'></i>
                                                            </Link>
                                                            {payment.status === 'created' && (
                                                                <button
                                                                    className='btn btn-outline-success'
                                                                    onClick={() => handleStatusUpdate(payment.id, 'approved')}
                                                                    title='Approve Payment'
                                                                >
                                                                    <i className='fas fa-check'></i>
                                                                </button>
                                                            )}
                                                            <button
                                                                className='btn btn-outline-danger'
                                                                onClick={() => handleDeletePayment(payment.id)}
                                                                title='Delete Payment'
                                                            >
                                                                <i className='fas fa-trash'></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Mobile Card View */}
                        <div className='d-lg-none'>
                            {loading ? (
                                <div className='text-center py-5'>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2">Loading payments...</p>
                                </div>
                            ) : payments.length === 0 ? (
                                <div className='text-center py-5'>
                                    <div className='text-muted'>
                                        <i className='fas fa-money-bill-wave fa-3x mb-3'></i>
                                        <p>No payments found</p>
                                    </div>
                                </div>
                            ) : (
                                <div className='payment-cards'>
                                    {payments.map((payment) => (
                                        <div 
                                            key={payment.id} 
                                            className='payment-card'
                                        >
                                            <div className='payment-card-header'>
                                                <div className='payment-reference'>
                                                    <strong>{payment.reference}</strong>
                                                    <div className='payment-order'>
                                                        <small className='text-muted'>Order: {payment.orderNo}</small>
                                                    </div>
                                                </div>
                                                <div className='payment-status'>
                                                    <span className={`badge ${getStatusBadge(payment.status)}`}>
                                                        {PaymentReceiveService.formatPaymentStatus(payment.status).label}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div className='payment-card-body'>
                                                <div className='payment-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-user me-2'></i>Customer:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        {payment.customerName}
                                                    </span>
                                                </div>
                                                
                                                <div className='payment-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-phone me-2'></i>Phone:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        {payment.mobileNumber}
                                                    </span>
                                                </div>

                                                <div className='payment-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-money-bill-wave me-2'></i>Amount:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        <span className='fw-bold text-success'>
                                                            {PaymentReceiveService.formatCurrency(payment.amount)}
                                                        </span>
                                                    </span>
                                                </div>

                                                <div className='payment-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-credit-card me-2'></i>Type:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        <span className='badge bg-info'>
                                                            {payment.paymentType}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div className='payment-card-footer'>
                                                <div className='payment-date'>
                                                    <i className='fas fa-calendar me-2 text-muted'></i>
                                                    <small className='text-muted'>
                                                        {formatDate(payment.createdAt)}
                                                    </small>
                                                </div>
                                                <div className='payment-actions'>
                                                    <Link
                                                        to={`/payments/receive/${payment.id}`}
                                                        className='btn btn-sm btn-outline-primary me-1'
                                                        title='View Details'
                                                    >
                                                        <i className='fas fa-eye'></i>
                                                    </Link>
                                                    <Link
                                                        to={`/payments/receive/edit/${payment.id}`}
                                                        className='btn btn-sm btn-outline-warning me-1'
                                                        title='Edit Payment'
                                                    >
                                                        <i className='fas fa-edit'></i>
                                                    </Link>
                                                    {payment.status === 'created' && (
                                                        <button
                                                            className='btn btn-sm btn-outline-success me-1'
                                                            onClick={() => handleStatusUpdate(payment.id, 'approved')}
                                                            title='Approve Payment'
                                                        >
                                                            <i className='fas fa-check'></i>
                                                        </button>
                                                    )}
                                                    <button
                                                        className='btn btn-sm btn-outline-danger'
                                                        onClick={() => handleDeletePayment(payment.id)}
                                                        title='Delete Payment'
                                                    >
                                                        <i className='fas fa-trash'></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Pagination */}
                    {pagination.total_pages > 1 && (
                        <div className='d-flex justify-content-between align-items-center mt-4'>
                            <div className='text-muted small'>
                                Page {pagination.current_page} of {pagination.total_pages}
                            </div>
                            <nav>
                                <ul className='pagination mb-0'>
                                    <li className={`page-item ${!pagination.has_prev_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(1)}
                                            disabled={!pagination.has_prev_page}
                                        >
                                            <i className="fas fa-angle-double-left"></i>
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_prev_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.current_page - 1)}
                                            disabled={!pagination.has_prev_page}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_next_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.current_page + 1)}
                                            disabled={!pagination.has_next_page}
                                        >
                                            Next
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_next_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.total_pages)}
                                            disabled={!pagination.has_next_page}
                                        >
                                            <i className="fas fa-angle-double-right"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                /* Payment Cards */
                .payment-cards {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }
                
                .payment-card {
                    background: white;
                    border: 1px solid #e9ecef;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }
                
                .payment-card:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    transform: translateY(-1px);
                    border-color: #007bff;
                }
                
                .payment-card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 0.75rem;
                    padding-bottom: 0.75rem;
                    border-bottom: 1px solid #f1f3f4;
                }
                
                .payment-reference {
                    flex: 1;
                }
                
                .payment-reference strong {
                    font-size: 1.1rem;
                    color: #212529;
                    display: block;
                    margin-bottom: 0.25rem;
                }

                .payment-order {
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                }

                .payment-order .badge {
                    font-size: 0.75rem;
                    align-self: flex-start;
                }
                
                .payment-status .badge {
                    font-size: 0.75rem;
                    padding: 0.375rem 0.75rem;
                }
                
                .payment-card-body {
                    margin-bottom: 0.75rem;
                }
                
                .payment-info-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.5rem;
                    min-height: 1.5rem;
                }
                
                .payment-info-row:last-child {
                    margin-bottom: 0;
                }
                
                .info-label-mobile {
                    font-size: 0.8rem;
                    font-weight: 600;
                    color: #6c757d;
                    flex-shrink: 0;
                    min-width: fit-content;
                    display: flex;
                    align-items: center;
                }
                
                .info-value-mobile {
                    font-size: 0.85rem;
                    color: #212529;
                    font-weight: 500;
                    text-align: right;
                    flex: 1;
                    margin-left: 0.5rem;
                    word-break: break-word;
                }
                
                .payment-card-footer {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 0.75rem;
                    border-top: 1px solid #f1f3f4;
                }
                
                .payment-date {
                    display: flex;
                    align-items: center;
                    flex: 1;
                }
                
                .payment-actions {
                    display: flex;
                    align-items: center;
                    gap: 0.25rem;
                }
                
                .payment-actions .btn {
                    width: 2.25rem;
                    height: 2.25rem;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                /* Enhanced Card Header for Mobile */
                .card-header-mobile {
                    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                    border-bottom: 1px solid #e9ecef;
                    border-radius: 0.75rem 0.75rem 0 0 !important;
                    padding: 1rem 1.5rem;
                    position: relative;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                }

                .card-title .card-label {
                    color: #212529;
                    font-weight: 600;
                    margin: 0;
                    font-size: 1.25rem;
                }

                .card-toolbar-mobile {
                    display: flex;
                    gap: 0.5rem;
                    align-items: center;
                    flex-wrap: wrap;
                }

                .btn-mobile {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    border-radius: 0.5rem;
                    font-weight: 500;
                    font-size: 0.875rem;
                    padding: 0.5rem 1rem;
                    border: none;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                }

                .btn-mobile:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
                }

                .btn-mobile i {
                    font-size: 0.875rem;
                }

                /* Enhanced Mobile Filters */
                .filters-container-mobile {
                    background: #f8f9fa;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    border: 1px solid #e9ecef;
                }

                .mobile-filters {
                    width: 100%;
                }

                .mobile-search-wrapper {
                    width: 100%;
                }

                .form-control-mobile-search {
                    height: 3rem;
                    border-radius: 1.5rem;
                    border: 2px solid #e9ecef;
                    padding-left: 3rem;
                    padding-right: 1rem;
                    font-size: 1rem;
                    background: white;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                    transition: all 0.3s ease;
                    font-weight: 400;
                }

                .form-control-mobile-search:focus {
                    border-color: #007bff;
                    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
                    transform: translateY(-1px);
                    outline: none;
                }

                .search-icon-mobile {
                    position: absolute;
                    left: 1rem;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #6c757d;
                    font-size: 1.1rem;
                    pointer-events: none;
                }

                .search-loading-mobile {
                    position: absolute;
                    right: 1rem;
                    top: 50%;
                    transform: translateY(-50%);
                }

                .mobile-filter-row {
                    display: flex;
                    gap: 0.75rem;
                    width: 100%;
                }

                .mobile-filter-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }

                .filter-label-mobile {
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: #495057;
                    margin-bottom: 0;
                }

                .form-select-mobile {
                    height: 2.75rem;
                    border-radius: 0.75rem;
                    border: 2px solid #e9ecef;
                    background: white;
                    font-size: 0.875rem;
                    font-weight: 500;
                    padding: 0.5rem 0.75rem;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                    transition: all 0.3s ease;
                }

                .form-select-mobile:focus {
                    border-color: #007bff;
                    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.15);
                    outline: none;
                }

                /* Mobile Results Summary Enhancement */
                .text-muted.small {
                    background: rgba(108, 117, 125, 0.1);
                    padding: 0.75rem 1rem;
                    border-radius: 0.5rem;
                    font-weight: 500;
                    text-align: center;
                    font-size: 0.875rem;
                    color: #495057;
                    border: 1px solid rgba(108, 117, 125, 0.1);
                }

                /* Mobile responsive adjustments */
                @media (max-width: 768px) {
                    /* Card Header Mobile */
                    .card-header-mobile {
                        padding: 1rem;
                        flex-direction: column;
                        align-items: stretch;
                        gap: 1rem;
                    }

                    .card-toolbar-mobile {
                        width: 100%;
                        justify-content: stretch;
                        gap: 0.5rem;
                    }

                    .btn-mobile {
                        flex: 1;
                        justify-content: center;
                        padding: 0.75rem 1rem;
                        font-size: 0.875rem;
                        min-height: 2.5rem;
                    }

                    .btn-text {
                        display: inline;
                    }

                    /* Filter Container Mobile */
                    .filters-container-mobile {
                        padding: 0.75rem;
                        margin: 0 -0.25rem 1rem -0.25rem;
                    }

                    .mobile-search-wrapper {
                        margin-bottom: 1rem;
                    }

                    .form-control-mobile-search {
                        height: 2.75rem;
                        font-size: 0.95rem;
                        padding-left: 2.75rem;
                    }

                    .search-icon-mobile {
                        left: 0.875rem;
                        font-size: 1rem;
                    }

                    .mobile-filter-row {
                        gap: 0.5rem;
                    }

                    .filter-label-mobile {
                        font-size: 0.8rem;
                    }

                    .form-select-mobile {
                        height: 2.5rem;
                        font-size: 0.8rem;
                        padding: 0.375rem 0.625rem;
                    }

                    /* Results Summary Mobile */
                    .text-muted.small {
                        padding: 0.5rem 0.75rem;
                        font-size: 0.8rem;
                        margin: 0 -0.25rem 1rem -0.25rem;
                    }
                }

                @media (max-width: 576px) {
                    /* Extra Small Mobile */
                    .card-header-mobile {
                        padding: 0.75rem;
                        border-radius: 0.5rem 0.5rem 0 0 !important;
                    }

                    .card-title .card-label {
                        font-size: 1.1rem;
                        text-align: center;
                    }

                    .btn-mobile {
                        padding: 0.625rem 0.75rem;
                        font-size: 0.8rem;
                        min-height: 2.25rem;
                    }

                    .btn-mobile .btn-text {
                        font-size: 0.8rem;
                    }

                    .filters-container-mobile {
                        padding: 0.5rem;
                        border-radius: 0.5rem;
                    }

                    .form-control-mobile-search {
                        height: 2.5rem;
                        font-size: 0.9rem;
                        padding-left: 2.5rem;
                        border-radius: 1.25rem;
                    }

                    .search-icon-mobile {
                        left: 0.75rem;
                        font-size: 0.9rem;
                    }

                    .mobile-filter-row {
                        flex-direction: column;
                        gap: 0.75rem;
                    }

                    .mobile-filter-item {
                        width: 100%;
                    }

                    .filter-label-mobile {
                        font-size: 0.75rem;
                    }

                    .form-select-mobile {
                        height: 2.25rem;
                        font-size: 0.75rem;
                        border-radius: 0.5rem;
                    }

                    .text-muted.small {
                        padding: 0.5rem;
                        font-size: 0.75rem;
                        border-radius: 0.375rem;
                    }

                    .payment-card {
                        padding: 0.75rem;
                        border-radius: 0.5rem;
                    }
                    
                    .payment-reference strong {
                        font-size: 1rem;
                    }
                    
                    .info-label-mobile {
                        font-size: 0.75rem;
                    }
                    
                    .info-value-mobile {
                        font-size: 0.8rem;
                    }
                    
                    .payment-info-row {
                        margin-bottom: 0.375rem;
                    }

                    .payment-actions .btn {
                        width: 2rem;
                        height: 2rem;
                        font-size: 0.8rem;
                    }
                }
            `}</style>
        </>
    )
}

export default PaymentReceiveList 